import { ToolboxItem } from "@/components/map-tool-box";
import { UrbanFeatureModeType } from "@/modules/urban-feature/urban-feature.types";
import {
  CrosswalkEditIcon,
  CrosswalkIcon,
  SpeedBumpEditIcon,
  SpeedBumpIcon,
  TrafficIcon,
  TrafficLightEditIcon,
  ViewIcon,
} from "components/icons";

export const urbanFeatureToolboxIcons: ToolboxItem<UrbanFeatureModeType>[] = [
  {
    name: "Mode",
    groups: [
      {
        text: "View",
        mode: UrbanFeatureModeType.View,
        icon: <ViewIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Traffic light",
    groups: [
      {
        text: "Add Traffic light",
        mode: UrbanFeatureModeType.AddTrafficLight,
        icon: <TrafficIcon className="h-5 w-5" />,
      },
      {
        text: "Edit Traffic light",
        mode: UrbanFeatureModeType.EditTrafficLight,
        icon: <TrafficLightEditIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Crosswalk",
    groups: [
      {
        text: "Add Crosswalk",
        mode: UrbanFeatureModeType.AddCrosswalk,
        icon: <CrosswalkIcon className="h-5 w-5" />,
      },
      {
        text: "Edit Crosswalk",
        mode: UrbanFeatureModeType.EditCrosswalk,
        icon: <CrosswalkEditIcon className="h-5 w-5" />,
      },
    ],
  },
  {
    name: "Speed bump",
    groups: [
      {
        text: "Add Speed bump",
        mode: UrbanFeatureModeType.AddSpeedBump,
        icon: <SpeedBumpIcon className="h-5 w-5" />,
      },
      {
        text: "Edit Speed bump",
        mode: UrbanFeatureModeType.EditSpeedBump,
        icon: <SpeedBumpEditIcon className="h-5 w-5" />,
      },
    ],
  },
];
